// TODO : Remove this replace when the envs are fixed
export const API_URL =
  process.env.REACT_APP_API_URL?.replace(',', '') || `http://localhost:4000`;
export const WS_URL =
  process.env.REACT_APP_WS_URL?.replace(',', '') || `ws://localhost:4000`;
